import { render, staticRenderFns } from "./intelligentSummary.vue?vue&type=template&id=6495fc54&scoped=true"
import script from "./intelligentSummary.vue?vue&type=script&lang=js"
export * from "./intelligentSummary.vue?vue&type=script&lang=js"
import style0 from "./intelligentSummary.vue?vue&type=style&index=0&id=6495fc54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495fc54",
  null
  
)

export default component.exports